module.exports = __webpack_public_path__ + "static/footer-img-ae7ff84917c45d56993946fc0c58dd8f.png";